import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

function HelmetWrapper({ 
  title = "helmet.title", 
  description = "helmet.description",
  keywords = "helmet.keywords",
  canonical,
  ogType = "website",
  ogImage = "/default-og-image.png",
  ogUrl,
  twitterCard = "summary_large_image",
  twitterSite = "@YourTwitterHandle"
}) {
  // Sécurité SSR : éviter window si non défini
  const currentUrl = typeof window !== "undefined" ? window.location.href : ogUrl || canonical || "";
  const language = localStorage.getItem('language') || 'en';
  const { t } = useTranslation();

  return (
    <Helmet>
      {/* Balises de base */}
      <html lang={language} />
      <meta charSet="utf-8" />
      <title>{t(title)}</title>
      <meta name="description" content={t(description)} />
      <meta name="keywords" content={t(keywords)} />
      <meta name="robots" content="index, follow" />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph (OG) */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={t(title)} />
      <meta property="og:description" content={t(description)} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={currentUrl} />

      {/* Twitter Cards */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={t(title)} />
      <meta name="twitter:description" content={t(description)} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content={twitterSite} />
    </Helmet>
  );
}

export default HelmetWrapper;